export interface FooterConfig {
  displayFooter?: boolean;
  label?: string;
}
